import {CartItemInterface, Customer} from '@/__generated__/__types__';
import {getFullName} from '@/_application/core/utils/common';
import {getProductItemImage, getProductUrl, Product} from '@/_application/modules/products/model/product';
import {ContentInput, CustomerDataInput} from '@kidslabs/mario-client-event-tracking';
import {getBasePrice, getFinalPrice} from '@/_application/modules/products/model/price';
import {CartItem} from '@/_application/modules/cart/models/cart';
import {getCartItemVariation} from '@/store/web-cart/web-cart.utils';

//get category data for cdp event field: main_category from product
const getProductCategory = (product: Product, parentProduct?: Product) => {
    //get product's second category -> level = 3 (root category level 1, first category level 2)
    const categoryLevel = 3;
    //variant will use categories of the parent product
    const categories = product.categories?.length ? product.categories : (parentProduct?.categories ?? []);

    //if product have many categories with same level, choose one with highest priority
    const categoriesList = categories.filter(category => category?.level === categoryLevel);
    const category = categoriesList.reduce(
        (previous, current) => (previous?.priority! > current?.priority! ? previous : current),
        categoriesList.at(0),
    );

    return category;
};

export const generateContentFromProduct = (product: Product, parentProduct?: Product) => {
    const mainCategory = getProductCategory(product, parentProduct);

    const content: ContentInput = {
        id: `${product?.id ?? 'no-product-id'}`,
        content_data: {
            name: product?.name as string,
            sku: product?.sku as string,
            page_url: getProductUrl(product, true),
            image_url: getProductItemImage(product),
            price: getFinalPrice(product).value ?? 0,
            original_price: getBasePrice(product).value ?? 0,
            main_category: mainCategory?.name ?? '',
            parent_item_id: parentProduct?.sku ?? '',
            is_parent: false,
        },
        quantity: 1,
    };
    return content;
};

export const generateContentsFromCartItems = (items: CartItemInterface[]) => {
    const contents: ContentInput[] = [];
    items.forEach((item: CartItem) => {
        let content;
        if (item?.__typename === 'ConfigurableCartItem') {
            const cartItem = getCartItemVariation(item);
            if (!cartItem?.product) return;
            content = generateContentFromProduct(cartItem.product);
        } else {
            content = generateContentFromProduct(item.product);
        }
        content.quantity = item.quantity;
        if (content.content_data) {
            content.content_data.row_total = item?.prices?.row_total?.value ?? 0;
        }
        contents.push(content);
    });

    return contents;
};

export const generateCustomerInput = (customer: Customer) => {
    if (!customer) {
        return;
    }

    const customerInput: CustomerDataInput = {
        id: customer?.phone_number,
        name: getFullName(customer),
        email: customer?.email as string,
        phone: customer?.phone_number,
    };

    return customerInput;
};
